import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'store_review_datetime': 'String',
};

export default gql(`
	mutation employee_store_review( ${ HelperGraphql.createFields( fields ) } ) {
	    employee( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
	        store_review_datetime
	    }
	}
`);

